<template>
  <span class="linkified-text">
    <template v-for="(part, index) in parts" :key="index">
      <a v-if="part.href" :href="part.href" target="_blank" rel="noopener noreferrer">{{ part.text }}</a>
      <template v-else>{{ part.text }}</template>
    </template>
  </span>
</template>

<script>
import { find } from "linkifyjs";

const SAFE_PROTOCOL = /^https?:\/\//i;
const TRAILING_PUNCTUATION = /[»“”…]+$/;

function splitByLinks(text) {
  const parts = [];
  let cursor = 0;

  for (const link of find(text, "url")) {
    if (!SAFE_PROTOCOL.test(link.href)) {
      continue;
    }

    const url = link.value.replace(TRAILING_PUNCTUATION, "");
    parts.push({ text: text.slice(cursor, link.start) });
    parts.push({ text: url, href: SAFE_PROTOCOL.test(url) ? url : `https://${url}` });
    cursor = link.start + url.length;
  }

  parts.push({ text: text.slice(cursor) });

  return parts.filter((part) => part.text);
}

export default {
  name: "LinkifiedText",
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  computed: {
    parts() {
      return splitByLinks(this.text);
    },
  },
};
</script>

<style lang="scss" scoped>
.linkified-text a {
  color: var(--primary-green-color);
  overflow-wrap: anywhere;

  &:hover {
    color: var(--primary-green-color-hover);
  }
}
</style>
